import usePartyStore from "../../stores/party.js";
import { log } from "@tumbodash/browserPackages";

const unsubscribe = usePartyStore.subscribe((_newState, _prevState) => {
	log.fx("module:party:listener");
});

export default unsubscribe;
